
const state = {
  serviceReceipt: {}
}

const mutations = {
  commitFormData_serviceReceipt (state, obj = {}) {
    state.serviceReceipt = JSON.parse(JSON.stringify(obj)) || {}
  }
}

const actions = {
  setServiceReceipt ({ commit, dispatch }, data) {
    commit('commitFormData_serviceReceipt', data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/serviceReceipt.js